import { Component, ChangeDetectionStrategy } from '@angular/core';
import { QrMenu } from './pages/qr-menu/qr-menu';

@Component({
  selector: 'app-root',
  imports: [QrMenu],
  template: '<app-qr-menu />',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {}
